@if (children?.length > 0) {
  <table class="w-full mt-4">
    <thead class="text-left border-b border-gray-300/50">
      <th class="w-1/12">Náhled</th>
      <th class="w-2/12">ID</th>
      <th class="w-1/12 truncate">Pořadí</th>
      <th class="w-2/12 truncate">Autor</th>
      <th class="w-4/12 truncate">Název</th>
      <!-- Actions column -->
      <th class="w-2/12"></th>
    </thead>
    <tbody>
      @for (child of children; track child; let last = $last) {
        <tr
          [ngClass]="{ 'border-b border-gray-300/80': !last }"
          >
          <td class="flex justify-start w-16 pr-0 min-w-8">
            <img
              [src]="_pictureService.getMainPictureFullFilename(child) | photoProxy"
              class="object-scale-down w-16 h-16 align-middle"
              alt="Náhled díla"
              loading="lazy"
              />
          </td>
          <td>
            <art-item-inventory-code [item]="child"></art-item-inventory-code>
          </td>
          <td>{{ child.parentOrder }}</td>
          <td>
            {{ _itemService.parseItemAuthors(child) }}
          </td>
          <td>{{ child.originalTitle }}</td>
          <td>
            <button
              class="hover:text-green-500"
              (click)="goToItemDetail(child.id)"
              mat-icon-button
              type="button"
              matTooltip="Přejít na detail díla"
              >
              <mat-icon svgIcon="mat:open_in_new"></mat-icon>
            </button>
            <button
              class="hover:text-blue-500"
              (click)="prepareItemQuickDialog(child.id)"
              mat-icon-button
              type="button"
              matTooltip="Zobrazit kartu díla"
              >
              <mat-icon svgIcon="mat:info"></mat-icon>
            </button>
          </td>
        </tr>
      }
    </tbody>
  </table>
}
